<template>
    <NewsArticle :model="model" />
</template>

<script>
import NewsArticle from '@/components/Pages/NewsArticle';

export default {
    name: 'NewsArticlePage',
    components: {
        NewsArticle,
    },
    async asyncData({ params, $axios, error, i18n, localePath, redirect, $getIsLangKoZhDe }) {
        if ($getIsLangKoZhDe()) {
            return redirect(localePath('/'));
        }

        let model = null;

        await $axios
            .$get(`/article/by-slug/${params.article}`)
            .then((res) => {
                if (res.success === 1) {
                    model = res.data;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('error.page_not_found.title') });
        }

        return { model };
    },
    head() {
        const meta = [
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.model.og_title || this.model.title,
            },
            {
                hid: 'title',
                name: 'title',
                content: this.model.og_title || this.model.title,
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.model.og_description || this.model.lead,
            },
            {
                hid: 'description',
                name: 'description',
                content: this.model.og_description || this.model.lead,
            },
            {
                property: 'article:published_time',
                content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
            },
            {
                name: 'publish-date',
                content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
            },
        ];

        if (this.model.cover_image_cropped) {
            meta.push({
                hid: 'og:image',
                property: 'og:image',
                content: this.model.cover_image_cropped,
            });
            meta.push({
                hid: 'og:image:url',
                property: 'og:image:url',
                content: this.model.cover_image_cropped,
            });
        }

        return {
            title: this.model.title,
            meta,
        };
    },
};
</script>

<style scoped></style>
